




import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import store from '@/store';
import * as CvSectionLinkItemStoreNew from '@/store/modules/cvSectionLinkItemNew';
import NewContainer from '@/containers/cv-section-link-item/new.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionLinkItemStoreNew.namespace
);

const fetch = async params => {
  const { cv_id, cv_section_link_id } = params;
  await store.dispatch(
    CvSectionLinkItemStoreNew.GetCvSectionLink.namespaced({
      params: { cv_id, id: cv_section_link_id },
    })
  );
};

export default Vue.extend({
  components: {
    NewContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionLinkItemStoreNew],
    };
  },
  computed: {
    ...mapGetters(['cvSectionLink']),
  },
});
